module.exports = __webpack_public_path__ + "static/whatisasession-cebe2a036abb4f94fe6d7dd1905918f4.svg";